import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setBreadcrumbsList } from 'src/store/breadcrumbs';

import { FinanceWorld } from './financeWorld/FinanceWorld';
import { TradingPeriod } from './tradingPeriod/TradingPeriod';
import { EconomyCalendar } from './economyCalendar/EconomyCalendar';
import { TradingInfluence } from './tradingInfluence/TradingInfluence';

import { BREADCRUMBS_DATA } from 'src/constants';

import './tradingSessions.scss';

export const TradingSessions = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBreadcrumbsList(BREADCRUMBS_DATA.TRADING_SESSIONS));
  }, [dispatch]);

  return (
    <div className="trading-sessions">
      <FinanceWorld />
      <TradingPeriod />
      <EconomyCalendar />
      <TradingInfluence />
    </div>
  );
};
